import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import useLanguage from '../../hooks/useLanguage';

/**
 * One supporting figure: value, label with an optional (i) tooltip saying how it is worked out, and one
 * line of context. A cell of the supporting sheet, so it reads quieter than the two KPIs above it.
 */
const ScoreCard = ({ value, label, sublabel, info }) => {
  const { t, isArabic } = useLanguage();
  return (
    <div className="ops-support-cell">
      <div className="ops-support-value">{value}</div>
      <div className="ops-support-label">
        {label}
        {info && (
          <OverlayTrigger
            placement="top"
            trigger={['hover', 'focus', 'click']}
            rootClose
            overlay={<Tooltip dir={isArabic ? 'rtl' : 'ltr'}>{info}</Tooltip>}
          >
            {/* role/tabindex live on the wrapping span — NOT the <i> — so the global touch
                `[role=button]::before` rule can't override Bootstrap Icons' glyph ::before. */}
            <span
              role="button"
              tabIndex={0}
              aria-label={typeof info === 'string' ? info : t('opsPerformance.info')}
              className="ops-support-info"
            >
              <i className="bi bi-info-circle" />
            </span>
          </OverlayTrigger>
        )}
      </div>
      {sublabel && <div className="ops-support-note">{sublabel}</div>}
    </div>
  );
};

export default ScoreCard;
